<div class="item-select-container left">
	<p>{{ availableLabelKey | translate }}</p>

	<div cdkDropList #todoList="cdkDropList" [cdkDropListData]="availableOptions" [cdkDropListConnectedTo]="[doneList]" class="item-select-list" (cdkDropListDropped)="dropInAll($event)">
		@for (item of availableOptions; track item) {
			<div class="item-select-box" cdkDrag>{{ item }}</div>
		}
	</div>
</div>

<div class="item-select-container right">
	<p>{{ selectedLabelKey | translate }}</p>

	<div cdkDropList #doneList="cdkDropList" [cdkDropListData]="selectedOptions" [cdkDropListConnectedTo]="[todoList]" class="item-select-list" (cdkDropListDropped)="dropInSelected($event)">
		@for (item of selectedOptions; track item) {
			<div class="item-select-box" cdkDrag>{{ item }}</div>
		}
	</div>
</div>
